const QUICK_VIEW_MOBILE_BREAKPOINT = 608;

if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
      this.variantsElement = this.querySelector('product-variants');
      this.sellingPlanElement = this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      this.optionValues = {}
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options.filter(x=>(requiredOptionsSettingUnique.indexOf(x)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && this.getOptionValues(x).length>1);
      
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
    }

    getOptionValues(optionName) {
      if (!this.optionValues[optionName]) {
        function filterUnique(value, index, array) {
          return array.indexOf(value) === index;
        }
        var ix = this.productData.options.indexOf(optionName);
        this.optionValues[optionName] = this.productData.variants.map(v=>v['option'+(1+ix)]).filter(filterUnique);
      }
      return this.optionValues[optionName];
    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.productData.options.length;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange(event) {
      //lightweight update of elements that not worth creating their own components
      var variant = event.detail.variant;
      var animate = event.detail.animate; // false on initial load, true on user interaction
      var deferredPrice = event.detail.deferredPrice;

      // Dispatch mainVariantChange for gallery updates (regular products)
      this.dispatchEvent(new CustomEvent('mainVariantChange', {detail: {variant: variant, animate: animate, deferredPrice: deferredPrice}}));
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        var percent = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        if (percent > 0) {
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });
      this.badgesSoldOut.forEach(element=>{
        element.textContent = variant.available ? '' : lngg.product_main__sold_out_message;
        element.style.display = variant.available ? 'none' : '';
      });}
  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
      }

      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('product-swatch.color-swatches');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            var pv = origSwatches.closest('product-variants');
            var tag = pv.outerHTML.replace('name="id"', '');
            var wrapper = document.createElement('div');
            wrapper.style.display = 'none';
            //must insert as Element, not HTML, otherwise the component would be reconstructed
            self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
            wrapper.innerHTML = tag;
            //move the swatches inside the add-to-cart-form component to use existing css.
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches'));
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
    }

    openOptions(e) {
      e.preventDefault()
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      if (this.optionsButton) this.optionsButton.setAttribute('aria-expanded', 'true');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        //this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      if (this.optionsButton) this.optionsButton.setAttribute('aria-expanded', 'false');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url+ '?view=quick-view';
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant.featured_media && super.isSwatchSelected() ? variant.featured_image : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      //update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.productData.options.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }
    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);

  class ProductCardSimple extends HTMLElement {
    constructor() {
      super();
      this.builder = this.closest('product-main-builder');
      this.variantInput = this.querySelector('.single-option-selector');
      this.quantityInput = this.querySelector('.quantity-input');
      this.button = this.querySelector('.add-to-cart');
      this.productAdded = false;
      this.skipNextSimpleVariant = false;

      this.button.addEventListener('click', this.onAddButtonClick.bind(this));

      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

    }

    onAddButtonClick(e) {
      e.preventDefault();
      if(!this.productAdded) {
        this.quickViewBtn.click();
        return;
      }
      this.addToBundle();
    }

    applyQuickViewVariant(variantData) {
      if (!variantData) {
        return;
      }

      const inputsContainer = this.querySelector('.add-to-cart-inputs');
      const priceValue = Number(variantData.price);
      const compareAtValue = Number(variantData.compare_at_price);

      if (inputsContainer && !Number.isNaN(priceValue)) {
        inputsContainer.dataset.price = priceValue;
      }

      const priceWrapper = this.querySelector('.price');
      if (priceWrapper && !Number.isNaN(priceValue) && typeof $s !== 'undefined') {
        const finalPriceEl = priceWrapper.querySelector('.final');
        if (finalPriceEl) {
          finalPriceEl.textContent = $s.formatMoney(priceValue).replace('.00', '');
        }

        const comparePriceEl = priceWrapper.querySelector('.compare');
        if (comparePriceEl) {
          if (!Number.isNaN(compareAtValue) && compareAtValue > priceValue) {
            comparePriceEl.classList.remove('hide');
            comparePriceEl.textContent = $s.formatMoney(compareAtValue).replace('.00', '');
          } else {
            comparePriceEl.classList.add('hide');
          }
        }
      }
    }

    moveQuickViewGallery(section) {
      if (!section) {
        return;
      }

      if (section.querySelector('product-main-builder.is-quickview')) {
        return;
      }

      const placeholder = section.querySelector('.qv-mobile-media-wrapper');
      const gallery = section.querySelector('.qv-desktop-media-wrapper');

      if (!placeholder || !gallery) {
        return;
      }

      if (!gallery.__originalParent) {
        gallery.__originalParent = gallery.parentNode;
        gallery.__originalNextSibling = gallery.nextElementSibling;
      }

      const shouldUseMobilePlacement = window.innerWidth <= QUICK_VIEW_MOBILE_BREAKPOINT;

      if (shouldUseMobilePlacement) {
        if (!placeholder.contains(gallery)) {
          placeholder.appendChild(gallery);
        }
        gallery.dataset.mobileMoved = 'true';
      } else if (gallery.dataset.mobileMoved === 'true') {
        const parent = gallery.__originalParent;
        if (parent) {
          const referenceNode = (gallery.__originalNextSibling && parent.contains(gallery.__originalNextSibling))
            ? gallery.__originalNextSibling
            : parent.firstChild;

          if (referenceNode) {
            parent.insertBefore(gallery, referenceNode);
          } else {
            parent.appendChild(gallery);
          }
        }
        delete gallery.dataset.mobileMoved;
      }

      if (this.quickViewGalleryResizeHandler) {
        window.removeEventListener('resize', this.quickViewGalleryResizeHandler);
      }

      this.quickViewGalleryResizeHandler = () => {
        if (!document.body.contains(section)) {
          window.removeEventListener('resize', this.quickViewGalleryResizeHandler);
          this.quickViewGalleryResizeHandler = null;
          return;
        }
        this.moveQuickViewGallery(section);
      };
      window.addEventListener('resize', this.quickViewGalleryResizeHandler);
    }

    addToBundle() {
      const wasManualSelection = this.skipNextSimpleVariant === true;
      const inputsContainer = this.querySelector('.add-to-cart-inputs');

      this.productAdded = !this.productAdded;

      let inputs = this.querySelectorAll('.add-to-cart-inputs input');

      inputs.forEach((input)=>{
        if(!this.productAdded || wasManualSelection) {
          input.removeAttribute('name');
          return;
        }
        input.setAttribute('name', input.dataset.name);
      });

      if (inputsContainer) {
        if (!this.productAdded) {
          delete inputsContainer.dataset.manualSelected;
        } else if (wasManualSelection) {
          inputsContainer.dataset.manualSelected = 'true';
        } else {
          delete inputsContainer.dataset.manualSelected;
        }
      }

      this.skipNextSimpleVariant = false;

      if (!this.productAdded && this.hasAttribute('data-pending-ring')) {
        this.removeAttribute('data-pending-ring');
      }

      this.button.textContent = !this.productAdded ? this.button.dataset.addLabel : this.button.dataset.removeLabel;

      if(this.builder) {
        this.builder.dispatchEvent(new CustomEvent('bundleChange', {detail: {productAdded: this.productAdded}}));
      }
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      if(!/([?&])view=/.test(qvUrl)) {
        qvUrl += (qvUrl.indexOf('?') === -1 ? '?view=quick-view' : '&view=quick-view');
      }
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }

          this.handleModalProductSelection(section);

          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    handleModalProductSelection(section) {
      if (!this.builder) {
        return;
      }
      let builderQuickView = section.querySelector('product-main-builder[data-quick-view="true"]');
      if (!builderQuickView) {
        this.moveQuickViewGallery(section);
      }
      let addToCartBtn = builderQuickView
        ? section.querySelector('button[type="submit"].btn')
        : section.querySelector('button.add');

      if (!addToCartBtn) {
        return;
      }

      let productCardSimple = this;
      section.addEventListener('click', function(e) {
        if (e.target === addToCartBtn || addToCartBtn.contains(e.target)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          if (builderQuickView) {
            let builderForm = section.querySelector('form[action*="/cart/add"]');

            if (builderForm) {
              let ringData = productCardSimple.extractRingBundleData(builderForm);
              productCardSimple.setAttribute('data-pending-ring', JSON.stringify(ringData));

              let variantData = null;
              let mainRingItem = ringData.items.find(item => {
                if (!item.properties) {
                  return true;
                }
                return item.properties['_bundle_item'] === 'main';
              }) || ringData.items[0];

              if (mainRingItem && builderQuickView) {
                let variantId = mainRingItem.id;
                let productJsonEl = builderQuickView.querySelector('script[data-product-json]');
                if (productJsonEl) {
                  try {
                    let productJson = JSON.parse(productJsonEl.textContent || '{}');
                    if (productJson && Array.isArray(productJson.variants)) {
                      variantData = productJson.variants.find(variant => variant.id == variantId);
                    }
                  } catch (error) {
                    // Swallow JSON parse errors to avoid interrupting quick view flow
                  }
                }
              }

              if (variantData) {
                productCardSimple.applyQuickViewVariant(variantData);
              }

              productCardSimple.skipNextSimpleVariant = true;
              productCardSimple.addToBundle();
              $s.closeModal();
            }
          } else {
            let variantInput = section.querySelector('[name="id"]');
            let qtyInput = section.querySelector('.quantity-input');
            if (variantInput && productCardSimple.variantInput) {
              productCardSimple.variantInput.value = variantInput.value;
            }
            if (qtyInput && productCardSimple.quantityInput) {
              productCardSimple.quantityInput.value = qtyInput.value;
            }
            productCardSimple.addToBundle();
            $s.closeModal();
          }
        }
      }, true);
    }

    extractRingBundleData(builderForm) {
      let items = [];
      let allFormInputs = builderForm.querySelectorAll('input, select, textarea');
      let ringBundleId = Date.now().toString();
      let itemGroups = {};

      allFormInputs.forEach(input => {
        let inputName = input.getAttribute('name') || input.getAttribute('data-name');
        if (!inputName) return;

        if (!inputName.startsWith('items[')) return;

        if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;

        let match = inputName.match(/^items\[(\d+)\]\[(.+)\]$/);
        if (!match) return;

        let itemIndex = match[1];
        let fieldPath = match[2];

        if (!itemGroups[itemIndex]) {
          itemGroups[itemIndex] = { properties: {} };
        }

        if (fieldPath === 'id') {
          itemGroups[itemIndex].id = input.value;
        } else if (fieldPath === 'quantity') {
          itemGroups[itemIndex].quantity = parseInt(input.value) || 1;
        } else if (fieldPath.startsWith('properties[')) {
          let propMatch = fieldPath.match(/^properties\[(.+)\]$/);
          if (propMatch) {
            let propName = propMatch[1];
            if (propName === '_bundle_id') {
              itemGroups[itemIndex].properties[propName] = ringBundleId;
            } else {
              itemGroups[itemIndex].properties[propName] = input.value;
            }
          }
        }
      });

      let sortedIndices = Object.keys(itemGroups).sort((a, b) => parseInt(a) - parseInt(b));
      sortedIndices.forEach(index => {
        items.push(itemGroups[index]);
      });

      return {
        items: items,
        bundleId: ringBundleId
      };
    }
  }
  customElements.define('product-card-simple', ProductCardSimple);

  class ProductMainBuilder extends ProductMain {
    constructor() {
        super();
        // Products without a dedicated *.quick-view template load their assigned
        // template into the modal; adopt the quick-view formatting (hidden Reset All,
        // modal anatomy, inline price) at runtime so every add-on modal matches.
        if (this.dataset.quickView !== 'true' && this.closest('.modal[data-modal="product-quick-view"], .tingle-modal')) {
          this.dataset.quickView = 'true';
          this.classList.add('is-quickview');
        }
        this.isQuickView = this.dataset.quickView === 'true';
        this.alreadySelectedVariant = false;
        this.mainProductData = this.productData;
        this.requiredOptions = this.mainProductData.options.filter(x=>(this.getOptionValues(x).length>1));
        this.stepsContainer = this.querySelector('.builder-blocks');
        this.mainProductTitleDesktopWrapper = this.querySelector('.product-title-wrapper');
        this.mobileDescriptionBlock = this.querySelector('.module.richtext') || this.querySelector('.module.main-description');
        this.mainProductTitleWrapper = this.mainProductTitleDesktopWrapper.firstElementChild
        this.mainProductTitle = this.mainProductTitleDesktopWrapper.querySelector('h1');
        this.modalsColorScheme = this.dataset.modalsColorScheme;
        this.stepsInfoData = JSON.parse(this.querySelector('[type="application/json"][data-steps-info]').textContent);
        this.builderResetBtn = this.querySelector('.builder-reset');
        this.builderButtons = this.querySelector('builder-buttons');
        this.extraImages = (this.querySelector('[type="application/json"][data-extra-images-json]')) ? JSON.parse(this.querySelector('[type="application/json"][data-extra-images-json]').textContent) : null;
        this.optionBadges = this.mainProductData.option_badges;

        this.querySelectorAll('form button.keen-arrow').forEach(btn=>{
          btn.addEventListener('click', (e)=>{
            e.preventDefault();
          })
        });

        this.updateInitializationStatus();
        this.addEventListener('variantChange', this.onFirstVariantChange.bind(this));
        if(this.isQuickView) {
          this.addEventListener('childElementLoaded', ()=>{
            this.initializeQuickviewDropdowns();
          });
          if(!this.dropdownObserver) {
            this.dropdownObserver = new MutationObserver((mutations)=>{
              let shouldInit = false;
              for(const mutation of mutations){
                for(const node of mutation.addedNodes){
                  if(node.nodeType !== 1) continue;
                  if(node.matches && (node.matches('product-swatch') || node.matches('.product-swatch'))){
                    shouldInit = true;
                    break;
                  }
                  if(node.querySelector && node.querySelector('product-swatch, .product-swatch')){
                    shouldInit = true;
                    break;
                  }
                }
                if(shouldInit) break;
              }
              if(shouldInit) {
                this.initializeQuickviewDropdowns();
              }
            });
            this.dropdownObserver.observe(this, {childList: true, subtree: true});
          }
        }

        document.addEventListener('click', (e)=>{
          if(e.target.closest('[data-oke-star-rating]')){
            var okeWidget = document.querySelector('[data-oke-widget]');
            if(!okeWidget) return;
            e.preventDefault();
            okeWidget.scrollIntoView({behavior: 'smooth'});
          }
        });

    }

    connectedCallback() {
      const waitingElements = this.querySelectorAll('tied-product, property-options');
        this.remaining = waitingElements.length;

        if (this.remaining === 0) {
            this.init();
            return;
        }

        this.addEventListener('childElementLoaded', (event) => {
            this.remaining--;
            // concat chield tiedProductData.media to main productData.media
            if(event.detail && event.detail.element.tagName === 'TIED-PRODUCT') {
              this.productData.media = this.normalizeMediaList(this.productData.media).concat(this.normalizeMediaList(event.detail.element.tiedProductData.media));
            }
            if (this.remaining === 0) {
                this.productData.media = Object.values(this.normalizeMediaList(this.productData.media).reduce((acc, obj) => {
                  acc[obj.id] = { ...acc[obj.id], ...obj }; // Merge properties
                  return acc;
                }, {}));

                if(this.extraImages && this.extraImages.length > 0) {
                  this.productData.media = this.productData.media.concat(this.normalizeMediaList(this.extraImages));
                }

                this.init();
            }
        });
    }

    normalizeMediaList(media) {
      return Array.isArray(media) ? media.filter(item => item && item.id) : [];
    }

    onFirstVariantChange (e) {
      if (e.detail.variant.id !== "99999999999999") {
        this.alreadySelectedVariant = true;
        this.updateInitializationStatus();
        return;
      }
      this.alreadySelectedVariant = false;
      this.querySelectorAll('product-swatch input').forEach(swatch => {
        swatch.checked = false;
      });
    }

    updateInitializationStatus () {
      if (this.alreadySelectedVariant) {
        this.classList.remove('unitialized-variant')
      } else {
        this.classList.add('unitialized-variant')
      }
    }

    addRecommendedProducts(callback) {
      var recommended = this.querySelectorAll('.featured-products-block product-card-simple');
      var addedInputs = this.querySelectorAll('input[name*="[id]');
      var recommendedAdded = 0;

      if(recommended.length > 0) {
        recommended.forEach((el, i)=>{
          if(!el.productAdded) return;
          var inputs = el.querySelectorAll('input[name*="items["');

          // Find all unique item indices in this product card
          // (builder quick views can have multiple items: main + tied products)
          var itemIndices = new Set();
          inputs.forEach((input)=>{
            var match = input.getAttribute('name').match(/^items\[(\d+)\]/);
            if (match) {
              itemIndices.add(parseInt(match[1]));
            }
          });

          // Create a mapping from old indices to new indices
          var indexMap = {};
          var sortedIndices = Array.from(itemIndices).sort((a, b) => a - b);
          sortedIndices.forEach((oldIndex) => {
            var newIndex = (addedInputs.length-1) + recommendedAdded;
            indexMap[oldIndex] = newIndex;
            recommendedAdded++;
          });

          // Rename all inputs using the index map
          inputs.forEach((input)=>{
            var name = input.getAttribute('name');
            var match = name.match(/^items\[(\d+)\]/);
            if (match) {
              var oldIndex = parseInt(match[1]);
              var newIndex = indexMap[oldIndex];
              var newName = name.replace(/^items\[(\d+)\]/, 'items[' + newIndex + ']');
              input.setAttribute('name', newName);
            }
          });
        });
      }
      callback();
    }

    init() {
      this.removeDuplicatedMedia();
      this.placeEmbroiderySteps();
      // Check URL parameter for 5-step variation
      const urlParams = new URLSearchParams(window.location.search);
      const isTestVariation = urlParams.get('view') === 'builder-test';
      // Use different selector based on variation
      const stepSelector = isTestVariation ? '.step' : 'product-swatch, .step';
      
      this.steps = this.querySelectorAll(stepSelector);
      this.buildSteps();
      this.currentStep = 1;
      this.renderStep(this.currentStep);
      this.renderArrows();
      this.renderTopNav();
      this.renderStepsInfo();
      this.updateStepsData();
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      this.onMediaChange();
      if(this.isQuickView) {
        this.initializeQuickviewDropdowns();
      }
      this.tiedProducts = this.querySelectorAll('tied-product');
      this.addEventListener('variantChange', (e)=>{
        // mainVariantChange is dispatched by parent class onVariantChange()
        this.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
        if(this.isQuickView) {
          this.initializeQuickviewDropdowns();
        }
      });
      this.addEventListener('stepChange', (e)=>{
        this.updateStepsData();
        this.refreshBuilderButtons();
      });

      const starsWidget = this.querySelector('[data-oke-star-rating]');
      const mainReviewsWidget = document.querySelector('[data-oke-widget]');

      if(starsWidget && mainReviewsWidget) {
        starsWidget.addEventListener('click', () => $s.scrollToElement(mainReviewsWidget))
      }

      this.applyPressedFrameDefaultSelections();

    }

    // Run before step discovery so progress, navigation and keyboard order agree.
    // Keep the section outside the controlling swatch: its radio change events
    // must never be interpreted as changes to the frame's Backing/Layout option.
    placeEmbroiderySteps() {
      if(!this.variantsElement) return;
      this.querySelectorAll('embroidery-component').forEach(component=>{
        const index = this.productData.options.indexOf(component.dataset.eligibilityOption);
        const target = Array.from(this.variantsElement.querySelectorAll('product-swatch, product-dropdown'))
          .find(option => Number(option.dataset.option) === index + 1);
        const section = component.closest('.embroidery-section');
        if(index >= 0 && target && section && target.nextElementSibling !== section) {
          target.insertAdjacentElement('afterend', section);
        }
        // Reorder presentation only: Shopify option indexes and cart identity stay intact.
        const followingIndex = this.productData.options.indexOf(component.dataset.followingOption);
        const following = Array.from(this.variantsElement.querySelectorAll('product-swatch, product-dropdown'))
          .find(option => Number(option.dataset.option) === followingIndex + 1);
        if(target && section && followingIndex >= 0 && following && following !== target && section.nextElementSibling !== following) {
          section.insertAdjacentElement('afterend', following);
        }
      });
    }

    shouldApplyPressedFrameDefaults() {
      return this.dataset.productHandle === 'pressed-frame-1';
    }

    refreshBuilderButtons() {
      if(this.builderButtons && typeof this.builderButtons.refresh === 'function') {
        this.builderButtons.refresh();
      }
    }

    getPressedFrameDefaultSelection() {
      return {
        Shape: ['Rectangle'],
        Size: ['16x20'],
        Color: [this.dataset.pressedFrameDefaultColor || 'Walnut Brown'],
        Style: ['Traditional'],
        Material: ['Glass'],
        Type: ['Regular Glass', 'Regular Glass Set']
      };
    }

    applyPressedFrameDefaultSelections() {
      if(!this.shouldApplyPressedFrameDefaults() || this.defaultSelectionsApplied) return;
      this.defaultSelectionsApplied = true;

      try {
        var defaults = this.getPressedFrameDefaultSelection();
        if(this.variantsElement && typeof this.variantsElement.applyDefaultSelection === 'function') {
          this.variantsElement.applyDefaultSelection(defaults);
        }

        var defaultedTiedProducts = [];
        this.isApplyingDefaultSelections = true;
        this.querySelectorAll('tied-product').forEach((tiedProduct)=>{
          if(typeof tiedProduct.applyDefaultSelection === 'function') {
            var applied = tiedProduct.applyDefaultSelection(defaults, {deferEvents: true});
            if(applied) defaultedTiedProducts.push(tiedProduct);
          }
        });
        this.dispatchPressedFrameDefaultTiedProductChange(defaultedTiedProducts);

        this.updateStepsData();
        this.refreshBuilderButtons();
        this.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
      } finally {
        this.isApplyingDefaultSelections = false;
        this.classList.add('pressed-frame-defaults-ready');
      }
    }

    dispatchPressedFrameDefaultTiedProductChange(tiedProducts) {
      var defaultedTiedProducts = tiedProducts || [];
      defaultedTiedProducts.forEach((tiedProduct)=>{
        if(typeof tiedProduct.collectBuilderSelectedOptionValues === 'function') {
          tiedProduct.tiedProductsSelectedOptionsValues = tiedProduct.collectBuilderSelectedOptionValues();
        }
      });

      var eventProduct = defaultedTiedProducts.find((tiedProduct)=>{
        return typeof tiedProduct.getCurrentVariant === 'function' && tiedProduct.getCurrentVariant();
      });

      if(!eventProduct) return;

      this.dispatchEvent(new CustomEvent('tiedProductVariantChange', {
        detail: {
          variant: eventProduct.getCurrentVariant(),
          element: eventProduct
        }
      }));
    }

    removeDuplicatedMedia(){
      const seen = new Set();
      this.querySelectorAll('product-gallery .image-wrap').forEach(el => {
        const mediaId = el.getAttribute("data-media-id");
        if (seen.has(mediaId)) {
            el.parentNode.removeChild(el);
        } else {
            seen.add(mediaId);
        }
      });
      const seen2 = new Set();
      this.querySelectorAll('product-thumbs .thumb-wrap').forEach(el => {
        const mediaId = el.getAttribute("data-media-id");
        if (seen2.has(mediaId)) {
            el.parentNode.removeChild(el);
        } else {
            seen2.add(mediaId);
        }
      });
    }

    updateStepsData() {
      this.stepsData = [...this.steps].map(step=>{
        return {
          'step_number': step.dataset.step,
          'title': step.querySelector('.option-title')?.textContent.trim(),
          'notRequired': (step.dataset.notRequired) ? step.dataset.notRequired=='true' : false,
          'values': this.getStepValues(step)
        }
      });
    }

    getStepValues(step) {
      // Check what's in the step
      const allDropdowns = step.querySelectorAll('.builder-dropdown');
      const allDropdownSelects = step.querySelectorAll('.builder-dropdown select');
      const allSwatches = step.querySelectorAll('product-swatch, .product-swatch');

      const elements = [...step.querySelectorAll('input:not([type="hidden"])[type="text"], input:not([type="hidden"])[type="date"], textarea[required], select, .swatch-group input:checked, input:not([type="hidden"])[type="checkbox"], .builder-dropdown select')];
      return elements.map(input=>{
        return {'value':input.value, 'label':step.dataset.label, notRequired: input.dataset.required == 'false' };
      });
    }

    resetSelections() {
      this.querySelectorAll('product-variants product-swatch, select:not(.rebuy-select), textarea, input:not([type="hidden"])[type="text"], input[type="date"], input[type="checkbox"], input[type="radio"]').forEach(el => {
        var optionValueEl = el.closest('.step').querySelector('.option-value');
        if (optionValueEl) {
          optionValueEl.textContent = '';
        }
        if (el.type == 'checkbox' || el.type == 'radio') {
          el.checked = false;
          return;
        }
        if(el.classList.contains('product-swatch')) {
          el.required(true);
          return;
        }
        if (el.type == 'text' || el.type == 'date' || el.type == 'textarea') {
          el.value = '';
          //trigger change on date to update event builder
          if(el.type == 'date') el.dispatchEvent(new Event("change"));
        }

        //if select has a selected option, reset it
        if (el.tagName == 'SELECT') {
          el.selectedIndex = 0;
        }
        
      });
      //reset requiredOptions
      this.requiredOptions = this.productData.options.filter(x=>this.getOptionValues(x).length>1);

      this.stepsData = [...this.steps].map(step=>{
        return {
          'step_number': step.dataset.step,
          'title': step.querySelector('.option-title').textContent.trim(),
          'values': []
        }
      });

      // if overview modal is open, close it
      if (document.querySelector('.builder-overview-modal')) {
        $s.closeModal();
      }

      this.refreshBuilderButtons();
      // Reset to deferred pricing mode when resetting selections
      // Use resetDeferred flag to clear any stored display price
      this.dispatchEvent(new CustomEvent('mainVariantChange', {detail: {variant: this.getCurrentVariant(), deferredPrice: true, resetDeferred: true}}));
      if(this.shouldApplyPressedFrameDefaults()) {
        this.defaultSelectionsApplied = false;
        this.classList.remove('pressed-frame-defaults-ready', 'pressed-frame-preview-ready');
        window.setTimeout(()=>this.applyPressedFrameDefaultSelections(), 0);
      }
    }

    renderStepsInfo() {
      this.stepsInfoData.forEach((stepInfo)=>{
        const infoIcon = `
          <div class="step-info-icon">
            <button type="button" class="btn-open">
              <svg aria-hidden="true" role="presentation" class="icon icon-info" viewBox="0 0 32 32">
                <path class="fill" d="M16,32C7.17763,32,0,24.82237,0,16S7.17763,0,16,0s16,7.17763,16,16-7.17763,16-16,16ZM16,1.68421C8.10609,1.68421,1.68421,8.10609,1.68421,16c0,7.89309,6.42188,14.31579,14.31579,14.31579,7.89309,0,14.31579-6.4227,14.31579-14.31579,0-7.89391-6.4227-14.31579-14.31579-14.31579ZM17.68421,23.57895h-1.68421c-.46546,0-.84211-.37664-.84211-.84211v-5.89474h-.84211c-.46546,0-.84211-.37664-.84211-.84211s.37664-.84211.84211-.84211h1.68421c.46546,0,.84211.37664.84211.84211v5.89474h.84211c.46546,0,.84211.37664.84211.84211s-.37664.84211-.84211.84211ZM16.01645,10.10526c-.46546,0-.85033-.37664-.85033-.84211s.36842-.84211.83388-.84211h.01645c.46546,0,.84211.37664.84211.84211s-.37664.84211-.84211.84211Z"/>
              </svg>
            </button>
          </div>
        `;
        const step = this.querySelector(`.step[data-step="${stepInfo.step_number}"]`)
        if(!step) return;
        let targetSelector = '.option-title';
        if(stepInfo.custom_selector.length > 0) targetSelector = stepInfo.custom_selector;
        step.querySelector(targetSelector).insertAdjacentHTML('beforeend', infoIcon);
        step.querySelector('.btn-open').addEventListener('click', (e)=>{
          e.preventDefault();
          this.openInfoModal(stepInfo.step_number);
        })
      });
    }

    openInfoModal(stepNumber) {
      stepNumber = stepNumber || this.currentStep;
      let stepData = this.stepsInfoData.find(step=>step.step_number==stepNumber);
      if (!stepData) return;
      const modalContent = `
        <div class="modal-content scheme ${this.modalsColorScheme}">
          <div class="modal-body">
            ${stepData.description}
            ${stepData.image ? `<div class="img-wrapper"><img src="${$s.imgUrlFilter(stepData.image, '800x')}" class="lazyload" /></div>` : ``}
          </div>
        </div>
      `;
      $s.openModal(modalContent, 'builder-step-info-modal');
    }

    onMediaChange() {
      const quickViewModal = this.closest('.modal[data-modal="product-quick-view"]');
      const isQuickView = this.dataset.quickView === 'true' || quickViewModal !== null;
      if($s.media.isSmall && !isQuickView){
        let topMobile = `
          <div class="builder-top-mobile container flex scheme-border-top scheme-border-bottom ${this.dataset.testFormatting == 'true' ? 'pdp-test-formatting-top' : ''}">${this.mainProductTitleDesktopWrapper.innerHTML}</div>
        `;
        const fragment = document.createRange().createContextualFragment(topMobile);
        this.parentNode.insertBefore(fragment, this);
        this.mainProductTitleDesktopWrapper.innerHTML = '';
        if (this.mobileDescriptionBlock) {
          const mobileHeader = this.parentNode.querySelector('.builder-top-mobile');
          mobileHeader.appendChild(this.mobileDescriptionBlock);
          // Long descriptions clamp on mobile with a "Read more" / "Read less" toggle
          if (this.mobileDescriptionBlock.textContent.trim().length > 100 && !mobileHeader.querySelector('.mobile-desc-toggle')) {
            this.mobileDescriptionBlock.classList.add('mobile-desc-clamped');
            const moreLabel = (typeof lngg !== 'undefined' && lngg.read_more_label) ? lngg.read_more_label : 'Read more';
            const lessLabel = (typeof lngg !== 'undefined' && lngg.read_less_label) ? lngg.read_less_label : 'Read less';
            const toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'mobile-desc-toggle';
            toggle.textContent = moreLabel;
            toggle.setAttribute('aria-expanded', 'false');
            toggle.addEventListener('click', ()=>{
              const expanded = this.mobileDescriptionBlock.classList.toggle('mobile-desc-clamped') === false;
              toggle.textContent = expanded ? lessLabel : moreLabel;
              toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            });
            mobileHeader.appendChild(toggle);
          }
        }
        setTimeout(()=>{
          const carousel = this.querySelector('component-carousel');
          if(!carousel) return;
          // The add-ons carousel is data-init-ondemand, so it is never auto-initialized.
          // On mobile we must CREATE it (not just refresh an existing one) or its slides
          // stay opacity:0 — the cards render blank and reserve a tall empty gap.
          if(carousel.sliderObj){
            carousel.removeSlider();
          }
          carousel.initSlider();
        },1)
      }else{
        this.mainProductTitleDesktopWrapper.innerHTML = this.mainProductTitleWrapper.outerHTML;
        if(this.parentNode.querySelector('.builder-top-mobile')){
          this.parentNode.querySelector('.builder-top-mobile').remove();
        }
        if (this.mobileDescriptionBlock) {
          const titleBlock = this.querySelector('.product-title-wrapper');
          titleBlock.parentNode.insertBefore(this.mobileDescriptionBlock, titleBlock.nextSibling);
        }
        //move builderButtons.parentNode at the bottom of this.stepsContainer
        this.stepsContainer.parentNode.appendChild(this.builderButtons.parentNode);
        setTimeout(()=>{
          const carousel = this.querySelector('component-carousel');
          if(!carousel) return;
          if(!carousel.sliderObj){
            carousel.initSlider();
          }
        },1)
      }
      if(isQuickView){
        const mobileHeader = this.parentNode.querySelector('.builder-top-mobile');
        if(mobileHeader){
          mobileHeader.remove();
        }
        if(this.mainProductTitleDesktopWrapper){
          const titleContainer = this.mainProductTitleDesktopWrapper.querySelector('.flex-1') || this.mainProductTitleDesktopWrapper;
          const priceBlock = this.querySelector('.block-price');
          const heading = titleContainer.querySelector('h1');
          if(priceBlock){
            priceBlock.classList.add('quickview-inline-price');
          }
          if(heading){
            let titleRow = titleContainer.querySelector('.builder-title-row');
            if(!titleRow){
              titleRow = document.createElement('div');
              titleRow.className = 'builder-title-row flex align-items-end justify-content-between';
              titleContainer.insertBefore(titleRow, heading);
            }
            if(!titleRow.contains(heading)){
              titleRow.insertBefore(heading, titleRow.firstChild);
            }
            if(priceBlock && !titleRow.contains(priceBlock)){
              titleRow.appendChild(priceBlock);
            }
          } else if(priceBlock && titleContainer && !titleContainer.contains(priceBlock)){
            titleContainer.appendChild(priceBlock);
          }
        }
        this.initializeQuickviewDropdowns();
      }

      if(this.querySelector('.builder-reset')){
        this.bindResetBtn(this.querySelector('.builder-reset'));
      }
      
    }

    initializeQuickviewDropdowns() {
      // Only create dropdowns for gem ring builder quick view
      if(!this.isQuickView || this.dataset.productHandle !== 'custom-ring-1') {
        return;
      }

      const placeholderLabel = (typeof lngg !== 'undefined' && lngg.general__forms__select_option_label) ? lngg.general__forms__select_option_label : 'Select option';

      const convertSwatch = (swatch) => {
        if(swatch.dataset.dropdownReady === 'true') {
          return;
        }

        const radios = Array.from(swatch.querySelectorAll('input[type="radio"]'));
        if(!radios.length) {
          return;
        }

        const labelText = swatch.dataset.customLabel || swatch.querySelector('.option-title')?.textContent.trim() || swatch.dataset.label || '';
        const dropdownWrapper = document.createElement('div');
        dropdownWrapper.className = 'builder-dropdown';

        const labelEl = document.createElement('label');
        labelEl.className = 'option-name small-label';
        labelEl.textContent = labelText;

        const selectWrapper = document.createElement('div');
        selectWrapper.className = 'select-wrapper';

        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('aria-hidden', 'true');
        icon.classList.add('icon', 'icon-arrow-down');
        icon.setAttribute('viewBox', '0 0 32 32');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M27,10,16,22,5,10');
        icon.appendChild(path);

        const selectEl = document.createElement('select');

        const isRequired = swatch.dataset.required !== 'false';
        let hasSelected = false;

        if(isRequired) {
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = placeholderLabel;
          placeholder.disabled = true;
          placeholder.selected = true;
          selectEl.appendChild(placeholder);
        }

        radios.forEach((radio)=>{
          const option = document.createElement('option');
          option.value = radio.value;
          let optionText = radio.parentElement.querySelector('.label-inner span')?.textContent.trim() || radio.value;
          const extra = radio.parentElement.querySelector('.additional-price')?.textContent.trim();
          if(extra) {
            optionText += ` ${extra}`;
          }
          option.textContent = optionText;
          if(radio.checked && !hasSelected) {
            option.selected = true;
            hasSelected = true;
            const placeholderOption = selectEl.querySelector('option[value=""]');
            if(placeholderOption) {
              placeholderOption.selected = false;
            }
          }
          if(radio.disabled || radio.hasAttribute('disabled')) {
            option.disabled = true;
          }
          selectEl.appendChild(option);
        });

        selectEl.addEventListener('change', ()=>{
          const targetRadio = radios.find(radio => radio.value === selectEl.value);
          if(targetRadio && !targetRadio.checked) {
            targetRadio.checked = true;
            targetRadio.dispatchEvent(new Event('change', {bubbles: true}));
            // Mark swatch as no longer required
            if(swatch.setAttribute && swatch.required) {
              swatch.setAttribute('data-required', 'false');
              if(typeof swatch.required === 'function') {
                swatch.required(false);
              }
            }
            // Trigger step change event to refresh builder buttons
            this.dispatchEvent(new CustomEvent('stepChange', {bubbles: true, detail: {}}));
          }
        });

        radios.forEach((radio)=>{
          radio.addEventListener('change', ()=>{
            if(radio.checked) {
              selectEl.value = radio.value;
            }
          });
        });

        selectWrapper.appendChild(icon);
        selectWrapper.appendChild(selectEl);
        dropdownWrapper.appendChild(labelEl);
        dropdownWrapper.appendChild(selectWrapper);

        const title = swatch.querySelector('.option-title');
        if(title) {
          title.style.display = 'none';
        }

        // Determine where to insert the dropdown
        // If the swatch itself has the 'step' class, it IS the step container, so insert inside it
        // Otherwise, insert in the parent before the swatch
        const isStepItself = swatch.classList.contains('step');
        const parent = swatch.parentElement;

        if(isStepItself) {
          // Swatch IS the step container - insert dropdown inside it at the beginning
          swatch.insertBefore(dropdownWrapper, swatch.firstChild);
          // Don't hide the swatch itself (it's the step container), just hide the button group
          const buttonGroup = swatch.querySelector('.swatch-group');
          if(buttonGroup) {
            buttonGroup.style.display = 'none';
            buttonGroup.hidden = true;
          }
        } else {
          // Swatch is inside a different step container - insert in parent before swatch
          parent.insertBefore(dropdownWrapper, swatch);

          // Hide the entire swatch since it's not the step container
          swatch.style.display = 'none';
          swatch.hidden = true;
        }

        swatch.dataset.dropdownReady = 'true';
      };

      const swatchSelectors = [
        'product-variants product-swatch',
        'product-variants .product-swatch',
        'tied-product product-swatch',
        'tied-product .product-swatch'
      ];
      const uniqueSwatches = new Set();
      swatchSelectors.forEach((selector)=>{
        this.querySelectorAll(selector).forEach((swatch)=>uniqueSwatches.add(swatch));
      });
      uniqueSwatches.forEach(convertSwatch);
    }

    bindResetBtn(button) {
      button.addEventListener('click', (e)=>{
        e.preventDefault();
        this.resetSelections();
        this.renderStep(1);

        // Reset deferred selection mode on variants element
        if (this.variantsElement) {
          this.variantsElement.deferredSelection = this.variantsElement.dataset.deferredSelection === 'true';
          this.variantsElement.selectedOptions = {};
          // Use variantChange with deferPrice=true instead of setVariant
          this.variantsElement.variantChange(this.mainProductData.variants[0], false, this.variantsElement.deferredSelection);
        }

        const gallery = this.querySelector('product-gallery');
        if(gallery) {
          gallery.slider.moveToSlide(0);
        }
        const thumbs = this.querySelector('product-thumbs');
        if(thumbs) {
          thumbs.slider.moveToSlide(0);
        }
      })
    }

    renderArrows(){
      if(this.steps.length === 0) return;
      if(this.arrows) {
        this.arrows.remove();
      }
      const arrows = document.createElement('div');
      let arrowsPosition = this.querySelector('.builder-arrows-position');
      arrows.classList.add('builder-arrows');
      if(arrowsPosition) {
        arrowsPosition.appendChild(arrows);
      } else {
        this.stepsContainer.parentNode.insertBefore(arrows, this.stepsContainer.nextSibling);
      }
      let stepsLength = [...this.steps].filter(step => !step.classList.contains('no-step')).length;
      let disabledPrev = this.currentStep == 1 ? 'disabled' : '';
      let disabledNext = this.currentStep == stepsLength ? 'disabled' : '';
      arrows.innerHTML = `
        <button class="arrow left ${disabledPrev}" type="button" aria-label="previous step">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="31" viewBox="0 0 32 31" fill="none">
          <path d="M9.29167 20.6666L4.125 15.4999M4.125 15.4999L9.29167 10.3333M4.125 15.4999L27.375 15.4999" stroke="#5A5949" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          ${lngg.product_main__builder__builder_prev_label}
        </button>
        <button class="arrow right ${disabledNext}" type="button" aria-label="next step">
          ${lngg.product_main__builder__builder_next_label}
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="31" viewBox="0 0 32 31" fill="none">
            <path d="M22.7083 10.3333L27.875 15.4999M27.875 15.4999L22.7083 20.6666M27.875 15.4999L4.625 15.4999" stroke="#5A5949" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `;
      this.arrows = arrows;
      this.arrows.querySelector('.left').addEventListener('click', (e)=>{
        e.preventDefault();
        this.arrows.querySelectorAll('.arrow').forEach(arrow=>arrow.classList.remove('disabled'));
        let currentStep = this.currentStep;
        let nextStep = this.currentStep - 1;
        let currentStepsLength = [...this.steps].filter(step => !step.classList.contains('no-step')).length;
        
        if(nextStep == 1 || nextStep < 1) {
          e.currentTarget.classList.add('disabled');
          currentStep = 1;
          this.renderStep(currentStep);
          return;
        }
        this.renderStep(currentStep-1);
      });
      this.arrows.querySelector('.right').addEventListener('click', (e)=>{
        e.preventDefault();
        this.arrows.querySelectorAll('.arrow').forEach(arrow=>arrow.classList.remove('disabled'));
        let currentStep = this.currentStep;
        let nextStep = this.currentStep + 1;
        let currentStepsLength = [...this.steps].filter(step => !step.classList.contains('no-step')).length;
        
        if(nextStep == currentStepsLength || nextStep > currentStepsLength) {
          e.currentTarget.classList.add('disabled');
          currentStep = currentStepsLength;
          this.renderStep(currentStep);
          return;
        }
        this.renderStep(nextStep);
      });
    }

    renderStep(step) {
      // Ensure step is a number to avoid string concatenation issues
      step = parseInt(step, 10);

      // Simple PDPs (no step blocks, dropdown-only options) have zero steps
      if(this.steps.length === 0) {
        this.currentStep = step;
        return;
      }

      this.steps.forEach(step=>{
        step.classList.remove('active')
        if($s.media.isSmall) step.setAttribute('aria-hidden', 'true');
      });
      this.steps[step-1].classList.add('active');
      if($s.media.isSmall) this.steps[step-1].removeAttribute('aria-hidden');
      this.currentStep = step;

      const blocks = this.querySelector('.builder-blocks');
      if (this.currentStep == 9) {
        blocks.classList.add('bloom-protection-active');
      } else {
        blocks.classList.remove('bloom-protection-active');
      }

      this.renderTopNav();
      this.renderArrows();
      // if step contains keen slider, refresh it
      const carousel = this.steps[step-1].querySelector('component-carousel');
      if(carousel && $s.media.isSmall) {
        carousel.removeSlider();
        carousel.initSlider();
      }
    }

    renderStepsNav() {
      let html = ``;
      this.steps.forEach((step, i)=>{
        if(step.classList.contains('no-step')) return;
        html += `
          <button class="step-nav-item ${i+1 == this.currentStep ? 'active' : ''}" type="button" aria-label="Step ${i+1}" data-step-nav="${i+1}">
            ${i+1}
          </button>
        `;
      });
      return html;
    }

    renderTopNav(force) {
      if(this.steps.length === 0) return;
      if(!this.topNav || force) {
        this.stepsContainer.parentNode.querySelector('.builder-top-nav')?.remove();
        const topNav = document.createElement('div');
        topNav.classList.add('builder-top-nav');
        topNav.innerHTML = `
          <div class="step-nav">
            <div class="container flex flex-wrap align-items-center scheme-border-bottom">
              <div>${lngg.product_main__builder__builder_steps_label}</div>
              <div class="step-nav-items flex flex-1 justify-content-between">
                ${this.renderStepsNav()}
              </div>
            </div>
            <div class="flex align-items-start">
              <div class="title" data-step="${this.currentStep}">
                <div class="step-title">
                  ${this.steps[this.currentStep-1].querySelector('.option-title')?.innerHTML}
                </div>
              </div>
              <button class="open-overview link" type="button">${lngg.product_main__builder__builder_overview_label}</button>
            </div>
          </div>
        `;
        this.stepsContainer.parentNode.insertBefore(topNav, this.stepsContainer);
        this.topNav = topNav;
        this.topNav.querySelector('.open-overview').addEventListener('click', (e)=>{
          this.renderOverviewModal();
        });
        this.topNav.querySelectorAll('.step-nav-item').forEach(item=>{
          item.addEventListener('click', (e)=>{
            e.preventDefault();
            this.renderStep(item.dataset.stepNav * 1);
          });
        });

        const infoBtn = this.topNav.querySelector('.step-title .btn-open');
        if (infoBtn) {
          infoBtn.addEventListener('click', (e)=>{
            e.preventDefault();
            this.openInfoModal(this.currentStep);
          });
        }

        return;
      }
      
      this.topNav.querySelector('.step-title').innerHTML =
        this.steps[this.currentStep-1].querySelector('.option-title')?.innerHTML;

      // Keep both elements' data-step in sync
      this.topNav.querySelector('.step-title').dataset.step = this.currentStep;
      this.topNav.querySelector('.title').dataset.step = this.currentStep; // <-- added

      this.topNav.querySelectorAll('.step-nav-item').forEach(item=>{
        item.classList.remove('active');
        if(item.dataset.stepNav == this.currentStep) {
          item.classList.add('active');
        }
      });
      const infoBtn = this.topNav.querySelector('.step-title .btn-open');
      if (infoBtn) {
        infoBtn.addEventListener('click', (e)=>{
          e.preventDefault();
          this.openInfoModal(this.currentStep);
        });
      }
    }

    renderOverviewModal() {
      // TODO: add to each step a data-value to store the option selected
      const overviewModal = document.createElement('div');
      // copy of builderResetBtn
      let builderResetBtn = this.builderResetBtn.cloneNode(true);
      const overviewModalSteps = this.renderOverviewModalSteps();
      builderResetBtn.classList.remove('small--hide');
      overviewModal.classList.add('builder-overview-modal');
      overviewModal.innerHTML = `
        <div class="modal-content scheme ${this.modalsColorScheme}">
          <div class="modal-header flex align-items-start">
            <div class="title h4">${lngg.product_main__builder__builder_overview_label}</div>
            ${overviewModalSteps.length > 0 ? builderResetBtn.outerHTML : ''}
          </div>
          <div class="modal-body">
            ${overviewModalSteps || lngg.product_main__builder__builder_overview_empty_label}
          </div>
        </div>
      `;

      overviewModal.querySelectorAll('[data-step-edit]').forEach(btn=>{
        btn.addEventListener('click', (e)=>{
          const step = btn.dataset.stepEdit;
          this.renderStep(step);
          $s.closeModal(overviewModal, 'builder-overview');
        })
      });

      if(overviewModal.querySelector('.builder-reset')) {
        this.bindResetBtn(overviewModal.querySelector('.builder-reset'));
      }
      
      $s.openModal(overviewModal, 'builder-overview');
    }
        
    renderOverviewModalSteps() {
      let html = '';
      this.steps.forEach((step, i)=>{
        
        const elements = step.querySelectorAll('input:not([type="hidden"])[type="text"], input:not([type="hidden"])[type="date"], textarea, select, input:checked');
        
        elements.forEach(element=>{
          if (element.value) {
            html += `
              <div class="step scheme-border-top ${i+1 == this.currentStep ? 'active' : ''}">
                <div class="flex justify-content-between">
                  <div>
                    <div class="step-title">${element.dataset.label || step.dataset.label}</div>
                    <div class="step-value">
                      ${element.value == 'on' ? lngg.product_main__builder__builder_is_gift_label : element.value}
                    </div>
                  </div>
                  <button class="link" data-step-edit="${i+1}" type="button" aria-label="Edit">${lngg.product_main__builder__builder_edit_label}</button>
                </div>
              </div>
            `;
          }
        })

      });

      if(html.length <= 0) html = '';

      return html;
    }

    buildSteps(){
      this.steps.forEach((step, i)=>{
        step.classList.add('step');
        step.dataset.step = i+1;
      })
    }
      
  }
  customElements.define('product-main-builder', ProductMainBuilder);

}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      if (this.button != this.mainAddButton) {
        this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      this.mainElement.addEventListener('variantChange', (e)=>{
        var requiredBtn = this.querySelector('.btn.selection-required');
        var soldOutMessage = this.querySelector('.sold-out-message');
        var soldOutTextElement = soldOutMessage ? soldOutMessage.querySelector('.btn') || soldOutMessage : null;
        var soldOutText = soldOutMessage && soldOutMessage.dataset.soldoutMessageSource === 'product-card'
          ? lngg.product_card_atc__sold_out_message
          : lngg.product_main__sold_out_message;
        if (this.required() && requiredBtn) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
          if (soldOutTextElement) soldOutTextElement.textContent = '';
          if (soldOutMessage) soldOutMessage.style.display = 'none';
        } else if(e.detail.variant && e.detail.variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          this.querySelector('.btn.add').style.display = '';
          if (soldOutTextElement) soldOutTextElement.textContent = '';
          if (soldOutMessage) soldOutMessage.style.display = 'none';
          if (requiredBtn) requiredBtn.style.display = 'none';
      	} else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.querySelector('.btn.add').style.display = 'none';
          if (soldOutTextElement) soldOutTextElement.textContent = soldOutText;
          if (soldOutMessage) soldOutMessage.style.display = '';
          if (requiredBtn) requiredBtn.style.display = 'none';
      	}
      });
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;
      this.setOriginalMediaOrder();

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      this.mainElement.addEventListener('mainVariantChange', this.onMainVariantChange.bind(this))
      this.mainElement.addEventListener('tiedProductVariantChange', this.onTiedProductVariantChange.bind(this))
      this.mainElement.addEventListener('embroideryGalleryChange', this.onEmbroideryGalleryChange.bind(this));
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    setOriginalMediaOrder() {
      Array.from(this.itemsWrapper?.children || []).forEach((item, index) => {
        if(!item.dataset.originalMediaIndex) {
          item.dataset.originalMediaIndex = index;
        }
      });
    }

    restoreOriginalMediaOrder() {
      Array.from(this.itemsWrapper?.children || [])
        .sort((a, b) => (a.dataset.originalMediaIndex || 0) - (b.dataset.originalMediaIndex || 0))
        .forEach(item => this.itemsWrapper.appendChild(item));
    }

    normalizeMediaSrc(src) {
      return (src || '')
        .split(',')[0]
        .trim()
        .split(' ')[0]
        .replace(/^https?:/, '')
        .split('?')[0];
    }

    getAlwaysVisibleMediaRefs() {
      return this.mainElement.productData.alwaysVisibleMedia || [];
    }

    getAlwaysVisibleMediaRefIndex(mediaOrElement) {
      if(!mediaOrElement) {
        return -1;
      }

      const mediaId = mediaOrElement.dataset?.mediaId || mediaOrElement.id;
      const mediaSrc = this.normalizeMediaSrc(
        mediaOrElement.dataset?.mediaSrc ||
        mediaOrElement.src ||
        mediaOrElement.preview_image?.src ||
        mediaOrElement.querySelector?.('[data-file]')?.dataset.file ||
        mediaOrElement.querySelector?.('[data-srcset]')?.getAttribute('data-srcset') ||
        mediaOrElement.querySelector?.('[data-bgset]')?.getAttribute('data-bgset')
      );

      return this.getAlwaysVisibleMediaRefs().findIndex((ref)=>{
        if(mediaId && ref.id && String(ref.id) == String(mediaId)) {
          return true;
        }

        return [ref.src, ref.preview_src].some((src)=>{
          const normalizedRefSrc = this.normalizeMediaSrc(src);
          return normalizedRefSrc && mediaSrc && normalizedRefSrc == mediaSrc;
        });
      });
    }

    isAlwaysVisibleMedia(mediaOrElement) {
      if(!mediaOrElement) {
        return false;
      }

      if(mediaOrElement.dataset && mediaOrElement.dataset.alwaysVisible == 'true') {
        return true;
      }

      return this.getAlwaysVisibleMediaRefIndex(mediaOrElement) >= 0;
    }

    getMediaForSlide(slide) {
      const mediaId = slide?.dataset?.mediaId;
      return this.mainElement.productData.media.find(m => String(m.id) == String(mediaId));
    }

    getPreferredVisibleSlide(variant, selector = '.media-wrap, .thumb-wrap') {
      const visibleSlides = Array.from(this.querySelectorAll(selector)).filter(slide => slide.style.display !== 'none');

      if(visibleSlides.length == 0) {
        return null;
      }

      // The layered-preview canvas IS the configured frame — while the compositor
      // is active (its slides visible) it outranks photo slides, so reorders and
      // navigation keep the preview in front instead of demoting it.
      const previewSlide = visibleSlides
        .filter(slide => slide.dataset.builderPreviewDynamic === 'true')
        .sort((a, b) => (parseFloat(a.dataset.originalMediaIndex) || 0) - (parseFloat(b.dataset.originalMediaIndex) || 0))[0];
      if(previewSlide) {
        return previewSlide;
      }

      // A photo matching the chosen embroidery outranks the variant's plain featured photo.
      if(this.embroideryMediaId) {
        const embroiderySlide = visibleSlides.find(slide => String(slide.dataset.mediaId) == String(this.embroideryMediaId));
        if(embroiderySlide) {
          return embroiderySlide;
        }
      }

      if(variant?.featured_media?.id) {
        const featuredSlide = visibleSlides.find(slide => String(slide.dataset.mediaId) == String(variant.featured_media.id));
        if(featuredSlide) {
          return featuredSlide;
        }
      }

      const filteredSlide = visibleSlides.find(slide => {
        const media = this.getMediaForSlide(slide);
        return !this.isAlwaysVisibleMedia(slide) && media && media.alt && media.alt !== '' && media.alt !== 'hide';
      });

      return filteredSlide || visibleSlides[0];
    }

    showPreferredVisibleItem(variant) {
      if(!this.slider) {
        return;
      }

      const targetSlide = this.getPreferredVisibleSlide(variant);
      if(targetSlide?.dataset?.mediaId) {
        this.showItem(targetSlide.dataset.mediaId, false);
      }
    }

    hasActiveMediaSelection(variant, selectedTiedProductOptions) {
      const hasMainSelection = variant?.options?.some(option => {
        return option && String(option).toLowerCase() !== 'unselected';
      });

      return Boolean(hasMainSelection || selectedTiedProductOptions?.length);
    }

    shouldMoveAlwaysVisibleMediaNearFront(variant, selectedTiedProductOptions) {
      return this.mainElement.productData.alwaysVisibleMediaNearFront === true &&
        this.hasActiveMediaSelection(variant, selectedTiedProductOptions);
    }

    getPersistentSlideSortIndex(slide) {
      // Compositor preview slides carry negative original indices and are not in
      // the always-visible refs — they lead the persistent group instead of
      // sinking to its end through the missing-ref fallback (which is what pushed
      // the configured-frame canvas to the last dot when deferred media loaded).
      if(slide.dataset && slide.dataset.builderPreviewDynamic === 'true') {
        const originalIndex = parseFloat(slide.dataset.originalMediaIndex);
        return isNaN(originalIndex) ? -1 : originalIndex;
      }

      const refIndex = this.getAlwaysVisibleMediaRefIndex(slide);
      return refIndex >= 0 ? refIndex : Number.MAX_SAFE_INTEGER;
    }

    applySelectedMediaOrder(variant, selectedTiedProductOptions) {
      this.restoreOriginalMediaOrder();

      if(!this.shouldMoveAlwaysVisibleMediaNearFront(variant, selectedTiedProductOptions)) {
        return;
      }

      const selectedSlide = this.getPreferredVisibleSlide(variant);
      if(!selectedSlide) {
        return;
      }

      const visibleSlides = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
        .filter(slide => slide.style.display !== 'none');
      const persistentSlides = visibleSlides
        .filter(slide => slide !== selectedSlide && this.isAlwaysVisibleMedia(slide))
        .sort((a, b) => {
          const aSortIndex = this.getPersistentSlideSortIndex(a);
          const bSortIndex = this.getPersistentSlideSortIndex(b);
          return (aSortIndex - bSortIndex) ||
            ((a.dataset.originalMediaIndex || 0) - (b.dataset.originalMediaIndex || 0));
        });
      const remainingSlides = visibleSlides.filter(slide => {
        return slide !== selectedSlide && !persistentSlides.includes(slide);
      });

      [selectedSlide, ...persistentSlides, ...remainingSlides].reverse().forEach(slide => {
        this.itemsWrapper.insertBefore(slide, this.itemsWrapper.firstElementChild);
      });
    }

    resetMediaVisibility() {
      this.restoreOriginalMediaOrder();
      this.embroideryMediaId = null;

      this.querySelectorAll('.media-wrap, .thumb-wrap').forEach(media => {
        media.style.display = 'block';
      });

      if(this.slider) {
        this.slider.refresh();
        const firstVisibleSlide = this.getPreferredVisibleSlide(null);
        if(firstVisibleSlide?.dataset?.mediaId) {
          this.showItem(firstVisibleSlide.dataset.mediaId, false);
        }
      }
    }

    filterMedia(variant, selectedTiedProductOptions) {
      var productData = this.mainElement.productData;
      var featuredMediaId = variant && variant.featured_media ? variant.featured_media.id : null;
      // Embroidered photos (and plain photos a matching embroidered one replaces) are decided by
      // the embroidery component; its filter returns null for everything else.
      var embroideryFilter = this.mainElement.querySelector('embroidery-component')?.galleryFilter?.(productData.media, variant);
      this.embroideryMediaId = embroideryFilter ? embroideryFilter.preferredMediaId : null;
      this.lastSelectedTiedProductOptions = selectedTiedProductOptions;

      // selectedTiedProductOptions is an array of strings in the format of 'option:value'
      // it's used to filter media based on the selected options of tied products
      if(selectedTiedProductOptions) {
        var selectedFilters = [];
        variant.options.forEach((option, i)=>{
          var optionName = productData.options[i];
          selectedFilters.push(optionName+':'+option);
        });
        selectedFilters = selectedFilters.concat(selectedTiedProductOptions.filter((item, index, self) => self.indexOf(item) === index));
      }
      productData.media.forEach((media)=>{

        if(media.alt == 'hide') {
          return;
        }

        const embroideryMatch = embroideryFilter ? embroideryFilter(media) : null;
        if(embroideryMatch != null) {
          this.querySelectorAll('[data-media-id="'+media.id+'"]').forEach(el=>el.style.display = embroideryMatch ? 'block' : 'none');
          return;
        }

        if(this.isAlwaysVisibleMedia(media)) {
          this.querySelectorAll('[data-media-id="'+media.id+'"]').forEach(el=>el.style.display = 'block');
          return;
        }

        // Never hide the featured media for the current variant
        if(featuredMediaId && media.id === featuredMediaId) {
          this.querySelectorAll('[data-media-id="'+media.id+'"]').forEach(el=>el.style.display = 'block');
          return;
        }

        var show = true;

        // For builder products: hide images without alt text when a real variant is selected
        if((!media.alt || media.alt=="") && variant && variant.option1 && variant.option1.toLowerCase() !== 'unselected') {
          show = false;
        }

        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';');

          // Check if alt text contains actual filter tags (Option:Value format)
          // If it's just a description without colons, hide the image -
          // the featured_media logic will show the correct one for the selected variant
          var hasFilterTags = filter.some(f => f.includes(':'));
          if (!hasFilterTags) {
            this.querySelectorAll('[data-media-id="'+media.id+'"]').forEach(el=>el.style.display = 'none');
            return;
          }

          if(selectedTiedProductOptions){
            var found = false;
            var matches = 0;

            selectedFilters.forEach((option)=>{
              var optionKey = option.split(':')[0];
              if(filter.includes(option) || filter.includes(optionKey+':*') || filter.includes(optionKey+':unselected')) {
                matches++;
              }
            });

            if(matches >= selectedFilters.length){
              found = true;
            }

            show = found;

          }else{
            // Check if this image has tags for ALL main variant options
            // If not, only show it when in "Unselected" state
            var hasAllOptions = true;
            // Use the actual product options instead of hardcoded values
            var mainOptions = productData.options || [];

            mainOptions.forEach((optionName) => {
              var hasThisOption = filter.some(f => f.split(':')[0].trim() === optionName);
              if(!hasThisOption) {
                hasAllOptions = false;
              }
            });

            // If image doesn't have all options, only show when variant option1 is "Unselected"
            if(!hasAllOptions && variant.option1 && variant.option1.toLowerCase() !== 'unselected') {
              show = false;
            } else {
              // Image has all options, check if they match
              filter.forEach((f)=>{
                if(show) {
                  var key = f.split(':')[0];
                  var values = f.split(':')[1];

                  var optionIndex = productData.options.findIndex(x=>x==key.trim());
                  if(optionIndex>=0 && values) {
                    var found = false;
                    var currentVariantValue = variant.options[optionIndex];

                    // Treat * and "unselected" as wildcards that match any value
                    // BUT: if the variant itself is "Unselected", don't match "unselected" tags
                    if(values.trim() === '*') {
                      found = true;
                    } else if(values.trim().toLowerCase() === 'unselected' && currentVariantValue && currentVariantValue.toLowerCase() !== 'unselected') {
                      // "unselected" in alt text only matches when variant is NOT "Unselected"
                      found = true;
                    } else {
                      values.split(',').forEach((value)=>{
                        if(currentVariantValue==value.trim()) {
                          found = true;
                        }
                      });
                    }
                    show = found;
                  }

                }
              });
            }
          }

        }

        if(show) {
          this.querySelectorAll('[data-media-id="'+media.id+'"]').forEach(el=>el.style.display = 'block');
        }
        else {
          this.querySelectorAll('[data-media-id="'+media.id+'"]').forEach(el=>el.style.display = 'none');
        }
      });

      // Never filter down to an empty gallery: products whose media carry no Option:Value
      // alt tags and whose variants have no featured media (e.g. the gift card) would
      // otherwise hide every image once a real variant is selected.
      var anyVisible = productData.media.some((media)=>{
        var el = this.querySelector('[data-media-id="'+media.id+'"]');
        return el && el.style.display != 'none';
      });
      if(!anyVisible) {
        productData.media.forEach((media)=>{
          if(media.alt == 'hide' || (embroideryFilter && embroideryFilter(media) === false)) return;
          this.querySelectorAll('[data-media-id="'+media.id+'"]').forEach(el=>el.style.display = 'block');
        });
      }

      this.applySelectedMediaOrder(variant, selectedTiedProductOptions);

      if(this.slider) {
        this.slider.refresh();
      }

      // Move to selected variant media first, then filtered media, then persistent context media.
      this.showPreferredVisibleItem(variant);

      this.captureCurrentPreviewImage();
    }
    
    captureCurrentPreviewImage() {
      const currentVariant = this.mainElement.getCurrentVariant ? this.mainElement.getCurrentVariant() : null;
      const preferredMediaWrap = this.getPreferredVisibleSlide(currentVariant, '.media-wrap');
      const visibleImageEl = preferredMediaWrap?.querySelector('img') || this.querySelector('.media-wrap:not([style*="display: none"]) img');
      const form = this.mainElement.querySelector('form');
      
      if (!visibleImageEl && form) {
        form.querySelector('input[name="properties[_preview_image_url]"]')?.remove();
      }
      if (visibleImageEl && form) {
        let imageUrl = visibleImageEl.dataset.file || visibleImageEl.getAttribute('data-srcset') || visibleImageEl.src;
        if (imageUrl && imageUrl.includes(',')) {
          imageUrl = imageUrl.split(',')[0].trim().split(' ')[0];
        }
        let existingInput = form.querySelector('input[name="properties[_preview_image_url]"]');
        if (existingInput) {
          existingInput.value = imageUrl;
        } else {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'properties[_preview_image_url]';
          hiddenInput.value = imageUrl;
          form.appendChild(hiddenInput);
        }
      }
    }

    onVariantChange() {
    }

    onMainVariantChange(e) {
      // For the builder, handle main variant changes to update gallery immediately
      var variant = e.detail.variant;
      var animate = e.detail.animate; // false on initial load, true/undefined on user interaction
      if(this.mainElement.productData.media && variant) {
        if(e.detail.resetDeferred) {
          this.resetMediaVisibility();
          this.captureCurrentPreviewImage();
          return;
        }

        var shouldFilterSilentDefault = this.mainElement.dataset.productHandle === 'pressed-frame-1' &&
          this.mainElement.defaultSelectionsApplied === true;

        // Skip filtering on ordinary initial load, but still filter the pressed-frame defaults
        // immediately so the page does not flash unrelated gallery images.
        if (animate === false && !shouldFilterSilentDefault) {
          return;
        }

        this.filterMedia(variant);

        // filterMedia already led with the matching embroidered photo; don't swap in the plain featured one.
        if(this.embroideryMediaId) return;

        // If variant has featured media, show that specific image
        if (variant.featured_media && variant.featured_media.id) {
          var featuredMediaEls = this.querySelectorAll('[data-media-id="'+variant.featured_media.id+'"]');

          if (featuredMediaEls.length > 0) {
            // Hide all visible media first (both main images and thumbnails)
            this.querySelectorAll('.media-wrap, .thumb-wrap').forEach(media => {
              media.style.display = this.isAlwaysVisibleMedia(media) ? 'block' : 'none';
            });
            // Show all elements with the featured media ID (main image + thumbnail)
            featuredMediaEls.forEach(el => el.style.display = 'block');

            // Refresh slider to recalculate height with new visibility
            if(this.slider) {
              this.slider.refresh();
              this.showItem(variant.featured_media.id, false);
            }
          } else {
            // Fallback: stay on the best visible media after filtering.
            if(this.slider) {
              this.slider.refresh();
              this.showPreferredVisibleItem(variant);
            }
          }
        } else {
          // No featured media, navigate slider to first visible after filtering
          var visibleMedia = this.querySelectorAll('.media-wrap:not([style*="display: none"])');
          if (visibleMedia.length > 0) {
            if(this.slider) {
              this.slider.refresh();
              this.showPreferredVisibleItem(variant);
            }
          }
        }
      }
    }

    isLayeredFrameGlassOnlyTiedProduct(element) {
      if(this.mainElement.dataset.productHandle !== 'pressed-frame-1') {
        return false;
      }
      if(!element || element.tagName !== 'TIED-PRODUCT') {
        return false;
      }
      if(typeof element.isGlassOnlyTiedProduct === 'function') {
        return element.isGlassOnlyTiedProduct();
      }

      const visualOptionNames = ['Glass', 'Type'];
      const configuredOptions = Array.isArray(element.options) ? element.options : [];
      if(configuredOptions.length > 0) {
        return configuredOptions.every(option => visualOptionNames.includes(String(option || '').trim()));
      }

      const optionLabels = Array.from(element.querySelectorAll('.product-swatch'))
        .map(optionElement => String(optionElement.dataset.label || '').trim());
      return optionLabels.length > 0 && optionLabels.every(option => visualOptionNames.includes(option));
    }

    onTiedProductVariantChange(e) {
      if(this.isLayeredFrameGlassOnlyTiedProduct(e.detail && e.detail.element)) {
        return;
      }

      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        var additionalFilters = e.detail.element.tiedProductsSelectedOptionsValues;
        this.filterMedia(this.mainElement.getCurrentVariant(), additionalFilters);
        //e.detail.element.hideMediaFromOtherProducts()
      }
    }

    onEmbroideryGalleryChange(e) {
      // Re-run the current filter with the new Yes/No, font or thread choice, and tell the
      // component whether the visible images changed so it only announces real updates.
      const visibleMedia = () => Array.from(this.querySelectorAll('[data-media-id]'))
        .filter(el => el.style.display !== 'none')
        .map(el => el.dataset.mediaId)
        .join();
      const before = visibleMedia();
      this.filterMedia(this.mainElement.getCurrentVariant(), this.lastSelectedTiedProductOptions);
      if(e.detail && visibleMedia() !== before) {
        e.detail.changed = true;
      }
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var allItems = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'));

        // Check display style directly instead of using $s.isVisible() to avoid timing issues
        var visibleItems = allItems.filter(x => x.style.display !== 'none');

        var index = visibleItems.findIndex(x=>x.dataset.mediaId==mediaId);

        if(index >= 0) {
          if(animate) {
            this.slider.moveToSlideRelative(index, true, 2000);
          } else {
            this.slider.moveToSlideRelative(index, true, 0);
          }
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        // Skip filtering on initial load (animate === false) to show all gallery images
        // This applies to both regular products and builders in "Unselected" state
        if (animate === false) {
          return;
        }

        this.filterMedia(variant);
        if(this.embroideryMediaId) return;
        if(variant.featured_media) {
          this.showItem(variant.featured_media.id, animate)
        } else {
          this.showPreferredVisibleItem(variant);
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: 1,
        }
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'].dots = this.querySelector('.keen-dots')
        }
        // Intelligems PDP test: dots inside the photo on all screen sizes
        var builderRoot = this.closest('product-main-builder');
        var testFormattingDots = builderRoot && builderRoot.dataset.testFormatting == 'true' ? this.querySelector('.keen-dots') : null;
        /*
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 0.001) +'rem)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }
        */
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          dotsMax: 10,
          ...(testFormattingDots ? {dots: testFormattingDots} : {}),
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]')?.classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        // Skip filtering on initial load (animate === false) to show all gallery images
        if (animate === false) {
          return;
        }

        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 4,
          spacing: 10,
          centered: false,
          vertical: false
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: 5,
          spacing: 10,
          centered: false,
          vertical: false
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: false,
          slidesPerView: 7,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            slidesPerView: 10
          } : {})
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.finalPriceElement = this.querySelector('.final');
      this.comparePriceElement = this.querySelector('.compare');
      this.fromPriceElement = this.querySelector('.from');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false

      if(this.mainElement.classList.contains('product-card')){
        var originalPricePrefix = '<span class="visually-hidden">Original price: </span>'
        var finalPricePrefix = '<span class="visually-hidden">. Final price: </span>'
      }else{
        var originalPricePrefix = '<span class="visually-hidden">Original price: </span>'
        var finalPricePrefix = '<span class="visually-hidden">. Final price: </span>'
      }

      this.listenEvents = ['variantChange','sellingPlanChange'];
      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          // For variantChange events, use the variant from the event (supports deferred pricing)
          // For other events, fall back to getCurrentPlan/getCurrentVariant
          var data = this.mainElement.getCurrentPlan() ||
            (event === 'variantChange' && e.detail && e.detail.variant) ||
            this.mainElement.getCurrentVariant();
        	if(data) {
            var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
            var displayBase = data.price + (Number(this.dataset.bfExtra) || 0);
            this.finalPriceElement.innerHTML = $s.formatMoney(displayBase * quantity).replace('.00','');

            if(data.compare_at_price > data.price) {
              this.comparePriceElement.classList.remove('hide');
              this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(data.compare_at_price * quantity).replace('.00','');
              this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(displayBase * quantity).replace('.00','');
            } else {
              this.comparePriceElement.classList.add('hide');
              this.comparePriceElement.innerHTML = '';
            }
            window.BlackFriday?.update(this, displayBase * quantity, window.BlackFriday.priceParts(this, displayBase, quantity), Boolean(this.mainElement.getCurrentPlan()));
            // if variant price is greater than product price_min, hide the .from element
            if (this.fromPriceElement){
              const priceMin = this.fromPriceElement.dataset.priceMin/1;
              if (data.price  > priceMin) {
                this.fromPriceElement.classList.add('hide');
              }
              else {
                this.fromPriceElement.classList.remove('hide');
              }
            }
        	} else {
        		this.finalPriceElement.innerHTML = '';
            this.comparePriceElement.innerHTML = '';
        	}
          this.mainElement.dispatchEvent(new CustomEvent('priceChange', {detail: {price: data.price * quantity}}));
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;

      // Deferred selection mode - for builder to show gallery without selecting size/color
      this.deferredSelection = this.dataset.deferredSelection === 'true';
      this.priceMin = this.dataset.priceMin ? parseInt(this.dataset.priceMin) : null;
      this.selectedOptions = {}; // Track which options user has explicitly selected
      // Option values ending in this suffix (e.g. "Embroidery" → "Linen Embroidery") belong to
      // internal fulfilment variants that a component assigns for the cart; they are never
      // offered as swatches or chosen as the displayed variant.
      this.hideOptionValueSuffix = (this.dataset.hideOptionValueSuffix || '').trim();

      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant, event.detail.deferredPrice);
        }
      })
      this.showOptionAdditionalPrice = this.dataset.showOptionAdditionalPrice;

      this.bindOptions();
      setTimeout(()=>{
        // In deferred selection mode, keep price at price_min on initial load
        this.variantChange(this.getCurrentVariant(), false, this.deferredSelection);
        this.bindInfoElements();
      }, 10);
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() {
      
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value);
    }

    isHiddenVariant(variant) {
      var suffix = this.hideOptionValueSuffix;
      if(!suffix || !variant || !Array.isArray(variant.options)) return false;
      return variant.options.some((value)=>{
        var text = String(value || '').trim();
        return text.length > suffix.length && text.slice(-suffix.length) === suffix;
      });
    }

    selectableVariants() {
      var variants = this.mainElement.productData.variants;
      if(!this.hideOptionValueSuffix) return variants;
      return variants.filter((variant)=>!this.isHiddenVariant(variant));
    }

    setVariant(variant, deferPrice) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        // Pass deferPrice if provided, otherwise default to false
        this.variantChange(variant, true, deferPrice);
      }
    }

    variantChange(variant, animate=true, deferPrice=false) {
      if(variant) {
        this.variantInput.value = variant.id;
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))

      // When deferring price, create a variant copy with price_min for display purposes
      // but still pass the real variant for gallery updates
      if (deferPrice && this.priceMin) {
        var displayVariant = { ...variant, price: this.priceMin, deferredPrice: true };
        this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant: displayVariant, animate, deferredPrice: true}}));
      } else {
        // Explicitly pass deferredPrice: false to end deferred pricing mode
        this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate, deferredPrice: false}}));
      }

      if (this.swatchImg) {
          //var variant = this.mainElement.productData.variants.
          var imageOut = this.swatchImg.dataset.imgOut;
          var options = ['option1', 'option2', 'option3'];
          var imgOption = options.splice(this.swatchImg.dataset.option/1 -1 ,1);
          this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
            var label = radio.parentNode.querySelector('.label-inner');
            
            var matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value && v[options[0]]==variant[options[0]] && v[options[1]]==variant[options[1]]);
            if (!matchingVariant) {
              matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value);
            }
            if (matchingVariant.featured_image) {
              if(imageOut){
                var img = label.querySelector('img');
                if(img){
                  img.remove();
                }
                img = document.createElement('img');
                img.src = $s.imgUrlFilter(matchingVariant.featured_image.src, '80x');
                img.setAttribute('alt', '');
                img.setAttribute('width', matchingVariant.featured_image.width);
                img.setAttribute('height', matchingVariant.featured_image.height);
                label.insertAdjacentElement('afterbegin', img);
                return;
              }
              label.style.backgroundImage = 'url(' +$s.imgUrlFilter(matchingVariant.featured_image.src, '80x')+ ')';
            } else {
              label.style.backgroundImage = '';
            }
          });

      }

    }

    calculateNewVariant(optionChanged, value) {
      // Every variant carrying the option value the user just chose.
      var candidates = this.selectableVariants().filter(x=>x.options[optionChanged]==value);
      if(candidates.length==0) return undefined;

      // Pick the candidate that PRESERVES the most previously-selected sibling option values.
      // This keeps any still-valid sibling (e.g. Art Glass) instead of silently flipping it to
      // whatever variant happens to be first; a sibling is only changed when no candidate for
      // the new selection can keep it. The scan is order-independent: the original left-to-right
      // narrowing could falsely drop a still-valid sibling because of option ordering.
      var prev = this.previousVariant;
      if(!prev) return candidates[0];

      // Weight earlier options more heavily so option priority (option1 > option2 > option3)
      // matches Shopify's variant picker and the prior left-to-right behavior: an earlier
      // sibling is preserved in preference to a later one when both cannot be kept at once.
      var numOptions = this.mainElement.productData.options.length;
      var bestVariant = candidates[0];
      var bestScore = -1;
      candidates.forEach((candidate)=>{
        var score = 0;
        this.mainElement.productData.options.forEach((option, index)=>{
          if(optionChanged==index) return;
          if(candidate.options[index]==prev.options[index]) score += (1 << (numOptions - index));
        });
        if(score > bestScore) {
          bestScore = score;
          bestVariant = candidate;
        }
      });
      return bestVariant;
    }

    bindOptions() {
      // Detect which option indices affect price by checking if different values have different prices
      this.priceAffectingOptions = this.detectPriceAffectingOptions();

      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;

          // Track that user has explicitly selected this option
          this.selectedOptions[optionIdx] = e.target.value;

          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);

          if (!this.deferredSelection) {
            // Not in deferred mode - just update normally
            this.variantChange(variant);
            return;
          }

          // Check how many price-affecting options user has selected
          var selectedPriceOptions = this.priceAffectingOptions.filter(idx => this.selectedOptions.hasOwnProperty(idx));
          var allPriceOptionsSelected = selectedPriceOptions.length === this.priceAffectingOptions.length;

          if (allPriceOptionsSelected) {
            // All price-affecting options selected - show actual variant price
            this.deferredSelection = false;
            this.variantChange(variant);
          } else if (selectedPriceOptions.length > 0) {
            // Some price-affecting options selected - show min price for current selections
            var minPriceForSelections = this.getMinPriceForSelections();
            var displayVariant = { ...variant, price: minPriceForSelections };
            this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant: displayVariant, animate: true, deferredPrice: true}}));
          } else {
            // No price-affecting options selected yet - keep price at min
            this.variantChange(variant, true, true);
          }
        });
      });
    }

    detectPriceAffectingOptions() {
      // Check each option to see if different values result in different prices
      var priceAffecting = [];
      var variants = this.selectableVariants();
      var numOptions = this.mainElement.productData.options.length;

      for (var optIdx = 0; optIdx < numOptions; optIdx++) {
        var optionKey = 'option' + (optIdx + 1);
        var pricesByValue = {};

        variants.forEach(v => {
          var optionValue = v[optionKey];
          if (!pricesByValue[optionValue]) {
            pricesByValue[optionValue] = new Set();
          }
          pricesByValue[optionValue].add(v.price);
        });

        // Check if any option value has variants with different prices
        // OR if different option values have different min prices
        var minPrices = Object.values(pricesByValue).map(priceSet => Math.min(...priceSet));
        var hasVariedPrices = new Set(minPrices).size > 1;

        if (hasVariedPrices) {
          priceAffecting.push(optIdx);
        }
      }

      return priceAffecting;
    }

    getMinPriceForSelections() {
      // Filter variants based on currently selected options, then find min price
      var variants = this.selectableVariants();

      Object.keys(this.selectedOptions).forEach(optIdx => {
        var optionKey = 'option' + (parseInt(optIdx) + 1);
        var selectedValue = this.selectedOptions[optIdx];
        variants = variants.filter(v => v[optionKey] === selectedValue);
      });

      if (variants.length === 0) {
        return this.priceMin;
      }

      return Math.min(...variants.map(v => v.price));
    }

    getDefaultValueCandidates(defaultValues, optionName) {
      var value = defaultValues ? defaultValues[optionName] : null;
      if(!value) return [];
      return Array.isArray(value) ? value : [value];
    }

    getAvailableOptionValues(optionName) {
      var optionIndex = this.mainElement.productData.options.indexOf(optionName);
      if(optionIndex < 0) return [];
      return [...new Set(this.selectableVariants().map(variant => variant.options[optionIndex]).filter(value => value))];
    }

    getDefaultSelectionValue(defaultValues, optionName) {
      var candidates = this.getDefaultValueCandidates(defaultValues, optionName);
      if(candidates.length === 0) return '';

      var availableValues = this.getAvailableOptionValues(optionName);
      return candidates.find(value => availableValues.includes(value)) || '';
    }

    applyDefaultSelection(defaultValues) {
      if(!defaultValues || !this.mainElement || !this.mainElement.productData) return false;

      var currentVariant = this.getCurrentVariant() || this.mainElement.productData.variants[0];
      if(!currentVariant) return false;

      var selectedVariantOptions = [...currentVariant.options];
      var appliedDefaults = {};

      this.mainElement.productData.options.forEach((optionName, index)=>{
        var selectedValue = this.getDefaultSelectionValue(defaultValues, optionName);
        if(!selectedValue) return;

        selectedVariantOptions[index] = selectedValue;
        this.selectedOptions[index] = selectedValue;
        appliedDefaults[optionName] = selectedValue;
        if(typeof this.mainElement.required === 'function') {
          this.mainElement.required(optionName, false);
        }
      });

      if(Object.keys(appliedDefaults).length === 0) return false;

      var variant = this.mainElement.productData.variants.find(candidate => {
        return candidate.options.length === selectedVariantOptions.length && candidate.options.every((value, index)=>value === selectedVariantOptions[index]);
      });

      if(!variant) {
        variant = this.mainElement.productData.variants.find(candidate => {
          return Object.keys(appliedDefaults).every(optionName => {
            var optionIndex = this.mainElement.productData.options.indexOf(optionName);
            return optionIndex < 0 || candidate.options[optionIndex] === appliedDefaults[optionName];
          });
        });
      }

      if(!variant) return false;

      this.deferredSelection = false;
      this.refreshOptions(-1, variant);
      this.variantChange(variant, false, false);
      return true;
    }

    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content" style="width: ${infoLink.dataset.width}rem">
                <img src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    getOptionValues(currentVariant) {
      
      var options = [];
      var selectable = this.selectableVariants();
      this.mainElement.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = selectable.map((variant)=>{return {
            value: variant.options[index], 
            available: variant.available
          }});
        }
        if(index==1) {
          var optionValues = selectable.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        if(index==2) {
          var optionValues = selectable.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;

        // In deferred selection mode, don't auto-select options the user hasn't chosen
        var userSelectedThis = this.selectedOptions.hasOwnProperty(index);
        var shouldShowSelected = !this.deferredSelection || userSelectedThis;

        if(index > updateOptionIndex) {
          // In deferred mode, don't pass a selected value for unselected options
          var selectedValue = shouldShowSelected ? currentVariant.options[index] : null;
          var skipAutoSelect = this.deferredSelection && !userSelectedThis;
          element.buildOptions(optionValues[index], selectedValue, skipAutoSelect);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          // In deferred mode, only show value for options user has selected
          if (!shouldShowSelected) {
            optionValueElement.innerHTML = '';
          } else {
            var optionValue = currentVariant.options[index];
            if(this.showOptionAdditionalPrice=='true') {
              var similarVariants = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2);
              if(similarVariants.length > 0) {
                var lowestPrice = similarVariants.reduce((prev, curr) => (prev.price < curr.price) ? prev : curr);
                var additionalPrice = currentVariant.price - lowestPrice.price;
                if(additionalPrice > 0 && similarVariants.length > 0) {
                  optionValue += ' <span class="additional-price">+$<span>' + $s.formatMoney(additionalPrice).replace(/[^0-9.,-]/g, '') + '</span></span>';
                }
              }
            }

            optionValueElement.innerHTML = optionValue;
          }
        }

      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      var divInfo = this.querySelector('.info');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.add('open')});
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.remove('open')});
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.colorSwatchesOptions = ["Color","Ribbon color","Ribbon Color","Locket Color","Frame Color","Thread Color"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.customLabel = this.dataset.customLabel;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);
      this.optionName = this.mainElement.productData.options[this.optionNumber-1];

      if(this.mainElement.productData.productOptionsIconMapping){
        this.optionsIcons = this.mainElement.productData.productOptionsIconMapping.filter(x=>x.option_name==this.optionName);
      }

      if(this.mainElement.optionBadges && this.mainElement.optionBadges.length > 0) {
        this.optionBadges = this.mainElement.optionBadges.filter(x=>x.option_name==this.optionName);
      }

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      // In deferred selection mode, don't show default values for option2+ (size, color)
      var isDeferredMode = this.variantsElement.deferredSelection;
      var optionIndex = this.optionNumber - 1;
      var skipAutoSelect = isDeferredMode && optionIndex > 0;
      var displayValue = skipAutoSelect ? '' : defaultValue;

    	var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
      var isColorSwatch = this.colorSwatchesOptions.indexOf(this.label)>-1;
      // Intelligems PDP test: as-typed "Label: Value" heading instead of "SELECT LABEL".
      // The .option-value span here is the first match inside the swatch, so the existing
      // refreshOptions/resetSelections value updates land on it instead of the hidden row.
      var testFormatting = this.mainElement.dataset.testFormatting == 'true';
      var titleHtml = this.customLabel && this.customLabel.length > 0 ? this.customLabel : lngg.product_main__builder__builder_option_label_prefix != undefined ? lngg.product_main__builder__builder_option_label_prefix + ' ' + this.label : this.label;
      if (testFormatting) {
        var titleBase = this.customLabel && this.customLabel.length > 0 ? this.customLabel : this.label;
        // "Begin Selecting Your Frame Shape" / "Select Frame Size" -> "Frame Shape" / "Frame Size"
        titleBase = titleBase.replace(/^\s*(begin selecting your|select)\s+/i, '');
        titleHtml = `${titleBase}: <span class="option-value">${displayValue || ''}</span>`;
      }
  		var html = `

      <div class="option-title-wrapper" style="display: flex; justify-content: space-between; align-items: center;">
        <span class="option-title" id="${this.getAttribute('aria-labelledby')}">
        ${titleHtml}
        ${this.infoLink}
        ${this.infoIcon}
        </span>
        ${this.getOptionLevelBadge()}
      </div>
      <div class="flex">
        <div class="option-name small-label ${isColorSwatch ? '' : 'hide'}">

          <span class="option-label hide">${this.label}:</span>
          <div aria-hidden="true" class="option-value">
            ${displayValue}
          </div>

        </div>
        <div class="swatch-group flex flex-wrap"></div>
      </div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, skipAutoSelect ? null : defaultValue, skipAutoSelect);
    }

    getOptionLevelBadge() {
      if (!this.optionBadges || this.optionBadges.length === 0) {
        return '';
      }

      var optionBadge = this.optionBadges.find(badge => 
        (badge.option_name === this.optionName || badge.option_name === this.label) && badge.option_value === ''
      );
      
      if (!optionBadge) {
        return '';
      }
      
      return `<div class="promotional-badge-inline">
        <div class="badge recommended" style="--scheme-badges-background: ${optionBadge.background_color}; --scheme-badges-label: ${optionBadge.text_color}; --badge-font-family: var(${optionBadge.font_family}); --badge-font-style: ${optionBadge.font_style};">
          ${optionBadge.label}
        </div>
      </div>`;
    }

    buildOptions(options, defaultValue, skipAutoSelect=false) {
    	var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }
      // Intelligems PDP test: group color swatches under Premium / Standard / Wide tier
      // labels when the option values carry tier names (mockup shows labeled clusters).
      var tierFor = (v) => /wide moulding/i.test(v) ? 'Wide' : (/^premium /i.test(v) || /antique gold/i.test(v) ? 'Premium' : 'Standard');
      var useTiers = this.mainElement.dataset.testFormatting == 'true'
        && this.colorSwatchesOptions.indexOf(this.label) > -1
        && options.some(o => /^premium /i.test(o.value) || /wide moulding/i.test(o.value) || /antique gold/i.test(o.value));
      // Intelligems AOV test: keep the tier ordering but drop the headers — the
      // color name renders as a tooltip span inside each swatch label instead
      // (aria-hidden: it duplicates the label's existing hidden name span; CSS
      // un-clips it on :hover/:focus-within).
      var hideTierLabels = this.mainElement.dataset.hideTierLabels == 'true';
      // Tier groups are emitted sequentially, so order values by tier first — the
      // oval palette (Antique Gold / Black / Toasted Walnut) interleaves them
      if (useTiers) {
        var tierRank = {Premium: 0, Standard: 1, Wide: 2};
        options = options.slice().sort((a, b) => tierRank[tierFor(a.value)] - tierRank[tierFor(b.value)]);
      }
      var lastTier = null;
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
        var icon = null;
        var badge = null;

        if(this.optionsIcons && this.optionsIcons.length>0) {
          icon = this.optionsIcons.find(x=>x.option_value==option.value);
        }

        if(this.optionBadges && this.optionBadges.length > 0) {
          badge = this.optionBadges.find(x=>x.option_value==option.value);
        }

        var tierTip = '';
        if (useTiers) {
          var tier = tierFor(option.value);
          if (hideTierLabels) {
            tierTip = `<span class="swatch-tier-tip" aria-hidden="true">${option.value}</span>`;
          } else if (tier !== lastTier) {
            if (lastTier !== null) html += `</div></div>`;
            html += `<div class="swatch-tier"><div class="swatch-tier-label">${tier}</div><div class="swatch-tier-swatches flex">`;
            lastTier = tier;
          }
        }

        var iconHtml = icon ? `<img class="custom-icon" src="${icon.icon_url}" alt="" width="${icon.icon_width}" height="${icon.icon_height}" />` : '';
        // Test formatting: wrap tile art so the border hugs the artwork (label below it)
        // and the baked-in padding of the preview assets can be cropped.
        if (iconHtml && this.mainElement.dataset.testFormatting == 'true') {
          iconHtml = `<span class="tile-art">${iconHtml}</span>`;
        }
  			html += `
          <div class="swatch" data-available="${option.available}">
            <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" data-label="${this.label}" />
  				  <label for="${id}">
              <div class="label-inner flex align-items-center justify-content-center animation ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}">
                ${iconHtml}
              	<span>${option.value}${soldOut}</span>
                ${(badge && badge.label) ? `<span class="badge" style="--scheme-badges-background: ${badge.background_color};--scheme-badges-label:${badge.text_color};--badge-font-family: var(${badge.font_family}); --badge-font-style: ${badge.font_style}">${badge.label}</span>` : ''}
              </div>${tierTip}
            </label>
          </div>
  			`;
  		});
      if (useTiers && lastTier !== null) html += `</div></div>`;
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        })
      }

      // Check the appropriate radio button for both required and non-required options
      // skipAutoSelect prevents visual selection in deferred mode (builder)
      if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
        group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
      } else if(!this.required() && !skipAutoSelect) {
        // Only check first option if not required (required options need explicit selection)
        // and not in deferred selection mode
        group.querySelector('input').checked = true;
      }

      if (!this.required()) {
        this.setAttribute('data-required', 'false');
      }

    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          var placeholder = select.querySelector('[disabled]');
          if (placeholder) placeholder.remove();
        }, {once: true});

        // Simple PDPs preselect the first value (the approved design shows the default
        // chosen, matching the old PDP); the "- Select -" placeholder stays only on
        // multi-step builders where deferred selection is the point.
        if (this.mainElement.classList.contains('simple-pdp')) {
          var simplePlaceholder = select.querySelector('[disabled]');
          if (simplePlaceholder) simplePlaceholder.remove();
          // Also drop the deferred-mode fake value (fake_variant_title) so the first
          // real option becomes the default instead of "Unselected"
          Array.from(select.options).forEach((opt)=>{
            if (opt.value === 'Unselected') opt.remove();
          });
          if (select.options.length) select.selectedIndex = 0;
          select.dispatchEvent(new Event('change', {bubbles: true}));
        }
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      // Test formatting echoes the selected value in the header ("Denomination: $50"),
      // matching the option-title pattern the swatch steps use.
      var valueEcho = this.mainElement.dataset.testFormatting == 'true' ? '<span class="option-value"></span>' : '';
      var html = `
        <label class="option-name small-label" for="${optionId}">
        ${this.infoIcon}${this.label}: ${valueEcho}
        ${this.infoLink}
        </label>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"/></svg>
          <select id="${optionId}" name="swatch-${optionId}" data-label="${this.label}"></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
      var echoEl = this.querySelector('.option-name .option-value');
      if(echoEl) {
        var select = this.querySelector('select');
        var syncEcho = ()=>{
          var selected = select.selectedOptions[0];
          echoEl.textContent = selected && !selected.disabled ? selected.value : '';
        };
        select.addEventListener('change', syncEcho);
        syncEcho();
      }
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (this.required()) {
  			html += `<option value="${defaultValue || ''}" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? lngg.product_main__sold_out_option_value : '');
  			html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
    }

    connectedCallback() {
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
    }

    onScroll(event) {
      var bounds = this.positionElement.getBoundingClientRect();
      if (bounds.bottom < 0) {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      } else {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      }

    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}



